import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
export { TitleContainer } from './TitleContainer';
export { ContentContainer } from './ContentContainer';
export var EvergreenContent = styled.div.withConfig({
  displayName: "partials__EvergreenContent",
  componentId: "sc-n0s6l6-0"
})(["display:flex;flex-direction:column;margin-top:12px;", ";"], minMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-top: 24px;\n    flex-direction: row;\n  "]))));
export var ContentBody = styled.div.withConfig({
  displayName: "partials__ContentBody",
  componentId: "sc-n0s6l6-1"
})(["font-size:16px;line-height:25.9px;p{font-size:16px;line-height:25.9px;}ul{li{margin-bottom:0.5rem;}}"]);
export var BackgroundDiv = styled.div.withConfig({
  displayName: "partials__BackgroundDiv",
  componentId: "sc-n0s6l6-2"
})(["background-color:", ";"], function (props) {
  return props.backgroundColor ? props.backgroundColor : props.theme.colors.uiLL;
});
export var Title = styled.h2.withConfig({
  displayName: "partials__Title",
  componentId: "sc-n0s6l6-3"
})(["font-size:26px;font-weight:700;line-height:36px;", ";"], minMediaQueries.tablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 37px;\n    line-height: 40px;\n  "]))));